import styled from 'styled-components';

import { PulseDot } from '../PulseDot';


function getRightAttr(retryLimit: number) {
  if (retryLimit === 1) { return '9px'; }
  if (retryLimit >= 10 && retryLimit < 20) { return '3px'; }
  if (retryLimit === 20) { return '2px'; }
  return '7px';
}

export const NumberDot = styled(PulseDot)<{ retryLimit: number }>`
  position: absolute;
  top: -12px;
  right: -4px;

  &:after {
    content: '${props => props.retryLimit}';
    font-size: 18px;
    line-height: 16px;
    position: absolute;
    right: ${({ retryLimit }) => getRightAttr(retryLimit)};
    top: 4px;
  }
`;
